module.exports = __webpack_public_path__ + "assets/TrapezoidHarmMeanDetailed.d3dc80e065e34f002440047fc215aab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TrapezoidHarmMeanDetailed.png
// module id = 594
// module chunks = 0